import React from 'react';
import { getRouteUrl } from '@css-xp/ppc-utils';
import { routePaths } from '@css-xp/ppc-constants';
import { SubscriptionWidgetItem } from '../../widget';
import { Maybe } from '@css-xp/graphtypes/src/generated-types-new';
import { SubscriptionQueryItem } from './types';

type Subscriptions = Maybe<Array<SubscriptionQueryItem>> | undefined;

export const getRecentlyViewedSubscriptionWidgetContent = (
  subscriptions: Subscriptions,
  heading?: string,
  version?: number
) => {
  if (!subscriptions || !subscriptions.length) {
    return null;
  }

  return subscriptions.map((subscription, index) => {
    if (!subscription || !subscription.transactionAccountId) {
      return null;
    }
    const URL = getRouteUrl(routePaths.entitlement, {
      txaId: subscription.transactionAccountId,
      entitlementId: subscription.id,
    });
    return <SubscriptionWidgetItem url={URL} key={index} {...subscription} heading={heading} version={version} />;
  });
};
